export const MOBILE_WIDTH = 320;
export const MOBILE_LANDSCAPE_WIDTH = 480;
export const TABLET_WIDTH = 768;
export const TABLET_LANDSCAPE_WIDTH = 1024;
export const DESKTOP_WIDTH = 1200;
export const DESKTOP_LARGE_WIDTH = 1500;
export const DESKTOP_WIDE_WIDTH = 1920;
